module.exports = __webpack_public_path__ + "img/services-payments.54e37a91.svg";